// Data Disclaimer Component
// Shows disclaimers when example/mock data is being displayed

import React from 'react';
import { Info, AlertTriangle } from 'lucide-react';
import { theme, getStatusTheme } from '../../styles/theme';

interface DataDisclaimerProps {
  type?: 'info' | 'warning';
  title?: string;
  message?: string;
  className?: string;
  showIcon?: boolean;
}

export const DataDisclaimer: React.FC<DataDisclaimerProps> = ({
  type = 'info',
  title,
  message,
  className = '',
  showIcon = true
}) => {
  const defaultMessages = {
    info: 'This data is for demonstration purposes only. Connect your real data sources to see your actual information.',
    warning: 'Example data is being displayed. Your real data will appear when you connect your accounts and devices.'
  };

  const defaultTitles = {
    info: 'Example Data',
    warning: 'Demo Mode'
  };

  const displayTitle = title || defaultTitles[type];
  const displayMessage = message || defaultMessages[type];

  const baseClasses = 'rounded-lg p-3 border';
  
  const typeClasses = {
    info: `${theme.colors.status.info.bg} ${theme.colors.status.info.text} ${theme.colors.status.info.border}`,
    warning: `${theme.colors.status.warning.bg} ${theme.colors.status.warning.text} ${theme.colors.status.warning.border}`
  };

  const iconClasses = {
    info: theme.colors.status.info.icon,
    warning: theme.colors.status.warning.icon
  };

  const classes = `${baseClasses} ${typeClasses[type]} ${className}`;

  const Icon = type === 'warning' ? AlertTriangle : Info;

  return (
    <div className={classes}>
      <div className="flex items-start">
        {showIcon && (
          <Icon className={`w-4 h-4 mr-2 mt-0.5 flex-shrink-0 ${iconClasses[type]}`} />
        )}
        <div className="flex-1">
          {displayTitle && (
            <h4 className="font-medium mb-1">{displayTitle}</h4>
          )}
          <p className="text-sm">{displayMessage}</p>
        </div>
      </div>
    </div>
  );
};

export default DataDisclaimer; 
